{
  "title": "Phantom Steed",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level illusion (ritual)",
  "level": 3,
  "castingTime": "1 minute",
  "range": "30 feet",
  "components": "V, S",
  "duration": "1 hour",
  "description": [
    "A Large quasi-real, horselike creature appears on the ground in an unoccupied space of your choice within range. You decide the creature’s appearance, but it is equipped with a saddle, bit, and bridle. Any of the equipment created by the spell vanishes in a puff of smoke if it is carried more than 10 feet away from the steed.",
    "For the duration, you or a creature you choose can ride the steed. The creature uses the statistics for a riding horse, except it has a speed of 100 feet and can travel 10 miles in an hour, or 13 miles at a fast pace. When the spell ends, the steed gradually fades, giving the rider 1 minute to dismount. The spell ends if you use an action to dismiss it or if the steed takes any damage."
  ],
  "spellLists": ["arcane-trickster", "wizard"]
}
